import React from 'react';

import useTranslation from '../../../../../hooks/useTranslation';
import useFormContext from '../../form/useFormContext';

const MessageSummary: React.FC = () => {
    const translated = useTranslation();
    const { state } = useFormContext();

    return (
        <li key="messageSummary" className="message-and-description__list-item">
            <h3 className="summary-description__title">
                {translated.crossBorderPayment.summary.messageAndDescription}
            </h3>
            <dl className="summary-description__term-list">
                <dt className="summary-description__spacing-to-title summary-description__term">
                    {translated.crossBorderPayment.description.title}
                </dt>
                <dd className="summary-description__info summary-description__extra-spacing">
                    {state.paymentDescription}
                </dd>
                <dt className="summary-description__term">{translated.crossBorderPayment.summary.messageToReceiver}</dt>
                <dd className="summary-description__info">{state.messageReceiver}</dd>
            </dl>
        </li>
    );
};

export default MessageSummary;
